export default function People() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos/">
          photography
        </a>
        {' > '}
        <a class="1" href="/photos/people">
          people
        </a>
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/people/adgam-grab_it.jpg" target="_blank">
                <img
                  src="/assets/photo/people/adgam-grab_it_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Grab It
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/people/blue.jpg" target="_blank">
                <img
                  src="/assets/photo/people/blue_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Blue
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/people/cas.jpg" target="_blank">
                <img
                  src="/assets/photo/people/cas_sm.jpg"
                  width="133"
                  height="200"
                />
                <br />
                Cas
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/people/dogbehindthefence.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/people/dogbehindthefence_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Dog Behind the Fence
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/people/flowers.jpg" target="_blank">
                <img
                  src="/assets/photo/people/flowers_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Flowers
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/people/looks_down2.jpg" target="_blank">
                <img
                  src="/assets/photo/people/looks_down2_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Looking Down
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/people/perfectloveperfecttrust.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/people/perfectloveperfecttrust_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Perfect Love
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/people/remindme.jpg" target="_blank">
                <img
                  src="/assets/photo/people/remindme_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Remind Me...
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/people/routine1.jpg" target="_blank">
                <img
                  src="/assets/photo/people/routine1_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Routine
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/people/shepperdorsheep.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/people/shepperdorsheep_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Shepperd or Sheep
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/people/silfo.jpg" target="_blank">
                <img
                  src="/assets/photo/people/silfo_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Silfo
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/people/sleeepnow.jpg" target="_blank">
                <img
                  src="/assets/photo/people/sleeepnow_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Sleep Now
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div align="center">
              <a
                href="/assets/photo/people/wetdoginthesnow.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/people/wetdoginthesnow_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Wet Dog in the Snow
              </a>
            </div>
          </td>
        </tr>
      </table>
      <p align="left">&nbsp;</p>
    </>
  );
}
